module.exports = __webpack_public_path__ + "assets/images/pages/hearthy/icon-hearthy-1.png?c0c95beb";